import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsEditNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M22.4 1.936l-.277-.278L19.457.231l-.8.119L5.131 13.88.4 22.683l.913.913 8.426-4.485 13.897-13.85.118-.8L22.4 1.936zM8.687 15.652l-.278-.276-1.865-1L17.236 3.684l2.046 1.095L20.3 6.687 9.608 17.378l-.921-1.726zm-2.925-.164l1.83.981.938 1.758-5.895 3.138 3.127-5.877zM21.3 5.69l-.921-1.726-.279-.277-1.867-1 1.029-1.029 2.047 1.1 1.018 1.902L21.3 5.69z"
        fill=""
      />
    </svg>
  )
);
SvgActionsEditNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgActionsEditNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsEditNormalSmall;
